import { useState, type FormEvent } from "react";
import type { Language } from "@contracts/index";
import { PortalLayout } from "../../components/PortalLayout";
import { ApiRequestError } from "../../lib/api";
import { clientApi } from "../../lib/client-api";
import { browserLanguage, portalText, rememberLanguage } from "../../lib/i18n";

/** Public entry: the client types their email and receives a single-use access link. */
export function Landing() {
  const [language, setLanguage] = useState<Language>(browserLanguage);
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "sending" | "sent" | "error" | "limited">("idle");
  const text = portalText(language);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setState("sending");
    try {
      await clientApi.requestAccess(email);
      setState("sent");
    } catch (e) {
      setState(e instanceof ApiRequestError && e.status === 429 ? "limited" : "error");
    }
  }

  function toggleLanguage() {
    const next: Language = language === "es" ? "en" : "es";
    rememberLanguage(next);
    setLanguage(next);
  }

  return (
    <PortalLayout
      actions={
        <button className="link light" onClick={toggleLanguage}>
          {text.other}
        </button>
      }
    >
      <section className="card narrow-card">
        <h1>{text.title}</h1>
        <p className="muted">{text.intro}</p>
        {state === "sent" ? (
          <p className="notice">{text.sent}</p>
        ) : (
          <form onSubmit={onSubmit}>
            <input
              type="email"
              required
              autoComplete="email"
              placeholder={text.emailPlaceholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="primary" type="submit" disabled={state === "sending"}>
              {state === "sending" ? text.sending : text.send}
            </button>
            {state === "error" && <p className="error">{text.genericError}</p>}
            {state === "limited" && <p className="error">{text.tooMany}</p>}
          </form>
        )}
      </section>
    </PortalLayout>
  );
}
